import { useFormikContext } from 'formik';
import React from 'react';
import { ShareLinkFormType } from '../link-config-form.factory';
import { SharePanelFormSection } from './section';

export const SharePanelFormConversationSectionLink = () => {
  const { values } = useFormikContext<ShareLinkFormType>();

  return (
    <SharePanelFormSection
      type='conversations'
      title='Conversations'
      subTitle={`Conversations are turned ${values.allow_comments ? 'on' : 'off'}`}
    />
  );
};
